/**
 * AdminUserDeactivateConfirmPage
 * Auto-generated from wireframe
 */
import React, { useState } from 'react';
import { Button, Input, Card } from '../components/ui';
import toast from 'react-hot-toast';

export function AdminUserDeactivateConfirmPage() {


  return (
    <div className="max-w-md mx-auto">
      <Card>
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Admin User Deactivate Confirm</h1>
        <p className='text-gray-600'>Page content goes here.</p>
      </Card>
    </div>
  );
}

export default AdminUserDeactivateConfirmPage;
